import React, { Component } from 'react';
import { Table} from 'antd';

export default class extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.chart = echarts.init(this.refs.chart);
        let respEchartData =  this.props.respEchartData;
        if(respEchartData) {
            this.initCharts(respEchartData);
        } 
    }

    componentWillReceiveProps(nextProps) {
        this.chart = echarts.init(this.refs.chart);
        let respEchartData =  nextProps.respEchartData;
        this.props = nextProps;
        if(respEchartData) {
            this.initCharts(respEchartData);
        }
    }

    initCharts(data) {
        const dataLength = Array.from(new Set(data.map(d => d.category))).length
        const axisStyle = this.props.axisStyle;
        
        var option = {
            title : {
                text: this.props.text?this.props.text : '不同部门填报/达标率分析统计',
                subtext: `${this.props.keywords.bgYearName} - ${this.props.keywords.endYearName}`,
                x: 'center'
            },
            tooltip : {
                trigger: 'axis'
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            toolbox: {
                show : true,
                feature : {
                    markUndo : {show: true},
                    markClear : {show: true},
                    mark : {show: true},
                    dataView : {show: false, readOnly: false},
                    magicType : {show: true, type: ['line', 'bar']},
                    myToolsPrice:{
                        show:true,
                        title:'X轴显示',
                        icon:'image://../images/change.svg',
                        onclick:() => {
                            this.props.changeStyle();
                        }
                    },
                    restore : {show: true},
                    saveAsImage : {show: true},
                    myTool21: {
                        show: true,
                        title: '平均值',
                        icon: 'image://../images/avg.svg',
                        onclick: () => {
                            this.props.handleChange({
                                mark: !this.props.keywords.mark,
                                v: Date.now()
                            })
                        }
                    },
                }
            },
            calculable : true,
            xAxis : [
                {
                    type : 'category',
                    axisLabel: {
                        rotate: this.props.axisStyle ? 50 : 0, 
                        // rotate:50,
                        interval:0,
                        formatter:function(value){  
                            //console.log(value);
                            var ret = "";//拼接加\n返回的类目项
                            var maxLength = axisStyle?15:6;//每项显示文字个数
                            if(!axisStyle && dataLength >= 35) {
                                maxLength = 1;
                                value  = value.length >= 10 ? (value.substring(0, 10) + "...") : value
                            }
                            if(!axisStyle && dataLength >= 20) {
                                maxLength = 2;
                                value  = value.length >= 25 ? (value.substring(0, 25) + "...") : value
                            } else if(!axisStyle && dataLength >= 15) {
                                maxLength = 4;
                                value  = value.length >= 50 ? (value.substring(0, 50) + "...") : value
                            } else if(!axisStyle && dataLength >= 10) {
                                maxLength = 6;
                                value  = value.length >= 80 ? (value.substring(0, 50) + "...") : value
                            } 
                            var valLength = value.length;//X轴类目项的文字个数
                            var rowN = Math.ceil(valLength / maxLength);
                            //类目项需要换行的行数
                            if (rowN > 1) {
                                for (var i = 0; i < rowN; i++) {
                                    var temp = "";//每次截取的字符串
                                    var start = i * maxLength;//开始截取的位置
                                    var end = start + maxLength;//结束截取的位置
                                    //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                                    temp = value.substring(start, end) + "\n";
                                    ret += temp; //凭借最终的字符串
                                }
                                return ret;
                            }else {
                                return value;
                            }

                        },
                        textStyle:{
                            color:"#000000" ,
                            fontSize : 14,
                            fontWeight: "bolder",
                        }
                    },
                    data : ['周一','周二','周三','周四','周五','周六','周日']
                }
            ],
            yAxis : [
                {
                    type : 'value',
                    min: this.props.minValue,
                    max: this.props.maxValue,
                    axisLabel : {
                        formatter: this.props.unit?'{value}%':'{value}'
                    }
                }
            ],
            legend: {
                data: ['邮件营销', '联盟广告', '视频广告', '直接访问', '搜索引擎']
            },
            series : [
                {
                    name:'填报率',
                    type: 'bar',
                    data:[11, 11, 15, 13, 12, 13, 10],
                    markPoint: this.props.keywords.mark ? {} : {
                        data: [
                            {type: 'max', name: '最大值'},
                            {type: 'min', name: '最小值'}
                        ]
                    },
                    markLine : {
                        data : [
                            {type : 'average', name: '平均值'}
                        ]
                    }
                }
            ]
        };

        var category = this.props.dataSource.map(item => {
            return item.orgName;
        });

        option.xAxis[0].data = category;
        
        var maps = {};
        (data || []).forEach(function(item) {
            if(!maps[item.series]) {
               maps[item.series] = []
            }
            
            maps[item.series].push({
                value: item.value,
                name: item.category
            });
        });

        var legendData = [];
        var legendOptions = this.props.legendOptions || []
        legendOptions.map(item => {
            legendData.push(item.legendName);
        });
        option.legend = {
            data:legendData,
            x:'left',
        };

        option.series = legendOptions.map(item => {
            var data = maps[item.legendName]
            
            return {
                name: item.legendName,
                type:'bar',
                data: data,
                markPoint: this.props.keywords.mark ? {} : {
                    data: [
                        {type: 'max', name: '最大值'},
                        {type: 'min', name: '最小值'}
                    ]
                },
                markLine: this.props.keywords.mark ? {} : {
                    data: [
                        {type: 'average', name: '平均值'}
                    ]
                }
            }
        });
        this.chart.setOption(option, true);
    }

    render() {
        const height = this.props.height ? this.props.height : 350;
        return (
            <div style={{width:'100%',marginTop:'10px'}}>
                <div style={{height}} ref="chart"></div>
                <div style={{height}}>
                    <Table 
                        bordered={true} 
                        columns={this.props.columns} 
                        dataSource={this.props.dataSource}  
                        pagination={false} 
                        scroll={{ y: height-50 }}
                        size="small" 
                    />
                </div>
            </div>
        )
    }
}